/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import { Fieldset } from 'primereact/fieldset';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import { Button } from 'primereact/button';
import '../styles.css';
import Swal from 'sweetalert2';
import trataLinks from '../../../modulos/function/trataLinkAceite';
import { ReenviaLink } from '../../../services/remessa';

const Status = {
    PENDENTE_INCLUSAO: 1,
    ENVIADO_BANCO: 2,
    RECEBIDO_BANCO: 3,
    ACEITO_BANCO: 4,
    RECUSADO_BANCO: 5,
    ERRO_PROCESSAMENTO: 6,
    CONCLUIDO: 7,
    CANCELADO: 8,
    PENDENTE_CANCELAMENTO: 9
};

const StatusRemessa = ({ dataParam, formulario }) => {
    const [data, setData] = useState(dataParam);
    const dadosForm = formulario;
    const statusId = data[0].StatusTransacao.id;
    const [selectedOption, setSelectedOption] = useState(null);
    const [isStatusRemessa, setStatusRemessa] = useState(false);
    const [smsInput, setSmsInput] = useState('');
    const [emailInput, setEmailInput] = useState('');
    const [whatsappInput, setWhatsappInput] = useState('');

    const handleButtonClick = async option => {
        const bodyRequest = {
            FormaEnvio: '',
            TipoAceite: dadosForm.TipoAceite,
            EmailEnvio: '',
            TelefoneEnvio: '',
            Inscricao: data[0].inscricao,
            ReenvioAtualizaConta: true
        };

        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const regexTelefone = /^\d{11}$/;

        switch (option) {
            case 'sms':
                bodyRequest.FormaEnvio = 1;
                bodyRequest.EmailEnvio = dadosForm.AssEmail;
                bodyRequest.TelefoneEnvio = smsInput;

                if (!smsInput) {
                    Swal.fire({
                        title: 'Erro',
                        text: 'Preencha o campo SMS!',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
                else {
                    if (regexTelefone.test(smsInput)) {
                        const data = await ReenviaLink(bodyRequest);

                        Swal.fire({
                            title: 'Sucesso',
                            text: data.mensagem,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        });
                    } else {
                        Swal.fire({
                            title: 'Erro',
                            text: 'Formato errado de Telefone!',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        });
                    }
                }

                break;
            case 'email':
                bodyRequest.FormaEnvio = 2;
                bodyRequest.EmailEnvio = emailInput;
                bodyRequest.TelefoneEnvio = dadosForm.Celular;

                if (!emailInput) {
                    Swal.fire({
                        title: 'Erro',
                        text: 'Preencha o campo Email!',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
                else {
                    if (regexEmail.test(emailInput)) {
                        const data = await ReenviaLink(bodyRequest);

                        Swal.fire({
                            title: 'Sucesso',
                            text: data.mensagem,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        });
                    } else {
                        Swal.fire({
                            title: 'Erro',
                            text: 'Formato errado de Email!',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        });
                    }
                }

                break;
            case 'whatsapp':
                bodyRequest.FormaEnvio = 3;
                bodyRequest.EmailEnvio = dadosForm.AssEmail;
                bodyRequest.TelefoneEnvio = whatsappInput;

                if (!whatsappInput) {
                    Swal.fire({
                        title: 'Erro',
                        text: 'Preencha o campo Telefone!',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
                else {
                    if (regexTelefone.test(whatsappInput)) {
                        const data = await ReenviaLink(bodyRequest);

                        Swal.fire({
                            title: 'Sucesso',
                            text: data.mensagem,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        });
                    }
                    else {
                        Swal.fire({
                            title: 'Erro',
                            text: 'Formato errado de Telefone!',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        });
                    }
                }

                break;
            default:
                break;
        }
    };

    const handleInputChange = (value, inputType) => {
        switch (inputType) {
            case 'sms':
                setSmsInput(value);
                break;
            case 'email':
                setEmailInput(value);
                break;
            case 'whatsapp':
                setWhatsappInput(value);
                break;
            default:
                break;
        }
    };

    const handleRadioChange = value => {
        setSelectedOption(value);
        setSmsInput('');
        setEmailInput('');
        setWhatsappInput('');
    };

    const dados = async () => {
        const resultado = await trataLinks(data);

        setStatusRemessa(resultado);
    };

    const styles = {
        botaoFechar: {
            width: '50px',
            height: '50px',
            marginLeft: '200px'
        }
    };

    useEffect(() => {
        dados();
    }, [data]);

    function inscricaoBodyTemplate(rowData) {
        return (
            <div>
                <div>{rowData.inscricao}</div>
            </div>
        );
    }

    function statusBodyTemplate(rowData) {
        const statusId = rowData.StatusTransacao.id;

        switch (statusId) {
            case Status.PENDENTE_INCLUSAO:
                return <div><div>Pendente de inclusão</div></div>;
            case Status.ENVIADO_BANCO:
                return <div><div>Enviado para o banco</div></div>;
            case Status.RECEBIDO_BANCO:
                return <div><div>Recebido pelo banco</div></div>;
            case Status.ACEITO_BANCO:
                return <div><div>Aceito pelo banco</div></div>;
            case Status.RECUSADO_BANCO:
                return <div><div>Recusado pelo banco</div></div>;
            case Status.ERRO_PROCESSAMENTO:
                return <div><div>Erro no Processamento</div></div>;
            case Status.CONCLUIDO:
                return <div><div>Concluído</div></div>;
            case Status.CANCELADO:
                return <div><div>Cancelado</div></div>;
            case Status.PENDENTE_CANCELAMENTO:
                return <div><div>Pendente de cancelamento</div></div>;
            default:
                return <div><div>Status desconhecido</div></div>;
        }
    }

    function dataBodyTemplate(rowData) {
        return moment(rowData.CreateAt).add(3, 'hours').format('DD/MM/YYYY hh:mm:ss');
    }

    function dataAceiteBodyTemplate(rowData) {
        if (rowData.updatedAt) {
            return moment(rowData.updatedAt).add(3, 'hours').format('DD/MM/YYYY hh:mm:ss');
        }

        return '';
    }

    const btnFecharModal = props => (
        <Button label='X' onClick={props} />
    );

    return (
        <div>
            <Popup
                modal
                trigger={
                    <button
                        type="submit"
                        icon="pi pi-plus"
                        className="btn-info"
                    >
                        Status Transação
                    </button>
                }
            >
                {close => (
                    <>
                        <div>
                            <div className="p-grid p-fluid">
                                <div className="p-col-8 p-md-8">
                                    <h1 style={{ textAlign: 'Right' }}>
                                        Status Transação
                                    </h1>
                                </div>
                                <div className="p-col-8 p-md-4" style={styles.botaoFechar}>
                                    {btnFecharModal(close)}
                                </div>
                            </div>
                            {isStatusRemessa && (
                                <div className="datatable-responsive-demo">
                                    <DataTable
                                        value={isStatusRemessa}
                                        className="p-datatable-responsive-demo"
                                    >
                                        <Column
                                            field="Inscricao"
                                            body={inscricaoBodyTemplate}
                                            header="Inscrição"
                                        />
                                        <Column
                                            field="CreateAt"
                                            body={dataBodyTemplate}
                                            header="Data Envio"
                                        />
                                        <Column
                                            field="UpdateAt"
                                            body={dataAceiteBodyTemplate}
                                            header="Atualizado em"
                                        />
                                        <Column
                                            field="StatusLink"
                                            body={statusBodyTemplate}
                                            header="Status"
                                        />
                                    </DataTable>

                                    {statusId == 5 && (<Fieldset legend="Reenvio de Link">
                                        <div className="p-grid p-fluid">
                                            <div className="p-col-12 p-md-4 p-lg-9 p-sm-6">
                                                <div className="status-remessa-container">
                                                    <div className="radio-input-group">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                value="sms"
                                                                checked={selectedOption === 'sms'}
                                                                onChange={() => handleRadioChange('sms')}
                                                            />
                                                            SMS
                                                        </label>
                                                        {selectedOption === 'sms' && (
                                                            <input
                                                                type="text"
                                                                placeholder="Digite o número do SMS"
                                                                value={smsInput}
                                                                onChange={e => handleInputChange(e.target.value, 'sms')}
                                                                style={{ marginLeft: '5px' }}
                                                            />
                                                        )}
                                                    </div>

                                                    <div className="radio-input-group">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                value="email"
                                                                checked={selectedOption === 'email'}
                                                                onChange={() => handleRadioChange('email')}
                                                            />
                                                            E-mail
                                                        </label>
                                                        {selectedOption === 'email' && (
                                                            <input
                                                                type="text"
                                                                placeholder="Digite o endereço de e-mail"
                                                                value={emailInput}
                                                                onChange={e => handleInputChange(e.target.value, 'email')}
                                                                style={{ marginLeft: '5px' }}
                                                            />
                                                        )}
                                                    </div>

                                                    <div className="radio-input-group">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                value="whatsapp"
                                                                checked={selectedOption === 'whatsapp'}
                                                                onChange={() => handleRadioChange('whatsapp')}
                                                            />
                                                            WhatsApp
                                                        </label>
                                                        {selectedOption === 'whatsapp' && (
                                                            <input
                                                                type="text"
                                                                placeholder="Digite o número do WhatsApp"
                                                                value={whatsappInput}
                                                                onChange={e => handleInputChange(e.target.value, 'whatsapp')}
                                                                style={{ marginLeft: '5px' }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                                                <div style={{ marginTop: '10px' }}>
                                                    {selectedOption === 'sms' && (
                                                        <Button label="Reenviar SMS" onClick={() => handleButtonClick('sms')} />
                                                    )}
                                                    {selectedOption === 'email' && (
                                                        <Button label="Reenviar E-mail" onClick={() => handleButtonClick('email')} />
                                                    )}
                                                    {selectedOption === 'whatsapp' && (
                                                        <Button label="Reenviar WhatsApp" onClick={() => handleButtonClick('whatsapp')} />
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </Fieldset>
                                    )}
                                    {statusId == 6 && (<Fieldset legend="Reenvio de Link">
                                        <div className="p-grid p-fluid">
                                            <div className="p-col-12 p-md-4 p-lg-9 p-sm-6">
                                                <div className="status-remessa-container">
                                                    <div className="radio-input-group">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                value="sms"
                                                                checked={selectedOption === 'sms'}
                                                                onChange={() => handleRadioChange('sms')}
                                                            />
                                                            SMS
                                                        </label>
                                                        {selectedOption === 'sms' && (
                                                            <input
                                                                type="text"
                                                                placeholder="Digite o número do SMS"
                                                                value={smsInput}
                                                                onChange={e => handleInputChange(e.target.value, 'sms')}
                                                                style={{ marginLeft: '5px' }}
                                                            />
                                                        )}
                                                    </div>

                                                    <div className="radio-input-group">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                value="email"
                                                                checked={selectedOption === 'email'}
                                                                onChange={() => handleRadioChange('email')}
                                                            />
                                                            E-mail
                                                        </label>
                                                        {selectedOption === 'email' && (
                                                            <input
                                                                type="text"
                                                                placeholder="Digite o endereço de e-mail"
                                                                value={emailInput}
                                                                onChange={e => handleInputChange(e.target.value, 'email')}
                                                                style={{ marginLeft: '5px' }}
                                                            />
                                                        )}
                                                    </div>

                                                    <div className="radio-input-group">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                value="whatsapp"
                                                                checked={selectedOption === 'whatsapp'}
                                                                onChange={() => handleRadioChange('whatsapp')}
                                                            />
                                                            WhatsApp
                                                        </label>
                                                        {selectedOption === 'whatsapp' && (
                                                            <input
                                                                type="text"
                                                                placeholder="Digite o número do WhatsApp"
                                                                value={whatsappInput}
                                                                onChange={e => handleInputChange(e.target.value, 'whatsapp')}
                                                                style={{ marginLeft: '5px' }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                                                <div style={{ marginTop: '10px' }}>
                                                    {selectedOption === 'sms' && (
                                                        <Button label="Reenviar SMS" onClick={() => handleButtonClick('sms')} />
                                                    )}
                                                    {selectedOption === 'email' && (
                                                        <Button label="Reenviar E-mail" onClick={() => handleButtonClick('email')} />
                                                    )}
                                                    {selectedOption === 'whatsapp' && (
                                                        <Button label="Reenviar WhatsApp" onClick={() => handleButtonClick('whatsapp')} />
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </Fieldset>
                                    )}
                                </div>
                            )}
                        </div>

                    </>
                )}
            </Popup>
        </div>
    );
};

export default StatusRemessa;
